import { useQuery } from '@tanstack/react-query';
import { apiCall } from '../../lib/api.js';
import { useAccessToken, requireToken } from '../../lib/use-access-token.js';

export interface CompanyGroup {
  companyId: string;
  companyName: string;
  companySlug: string;
  roles: string[];
}

export interface MeResponse {
  userId: string;
  email: string;
  displayName: string;
  ionicRoles: string[];
  companies: CompanyGroup[];
}

export function useMe() {
  const { token, loading: tokenLoading, error: tokenError } = useAccessToken();

  const query = useQuery<MeResponse, Error>({
    queryKey: ['me', token],
    enabled: !!token,
    queryFn: async ({ signal }) =>
      apiCall<MeResponse>('/v1/me', { token: requireToken(token), signal }),
    staleTime: 60_000,
    retry: false,
  });

  return {
    me: query.data,
    loading: tokenLoading || query.isLoading,
    error: tokenError ?? query.error,
    refetch: query.refetch,
  };
}
